/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Whtr_Band_HealthyInputs */

const en_us2_body_assessment_whtr_band_healthy = /** @type {(inputs: Body_Assessment_Whtr_Band_HealthyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Healthy range`)
};

const pt_br2_body_assessment_whtr_band_healthy = /** @type {(inputs: Body_Assessment_Whtr_Band_HealthyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faixa saudável`)
};

const es_419_body_assessment_whtr_band_healthy = /** @type {(inputs: Body_Assessment_Whtr_Band_HealthyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rango saludable`)
};

const pt_pt2_body_assessment_whtr_band_healthy = /** @type {(inputs: Body_Assessment_Whtr_Band_HealthyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intervalo saudável`)
};

const fr_fr2_body_assessment_whtr_band_healthy = /** @type {(inputs: Body_Assessment_Whtr_Band_HealthyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zone saine`)
};

const de_de2_body_assessment_whtr_band_healthy = /** @type {(inputs: Body_Assessment_Whtr_Band_HealthyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesunder Bereich`)
};

const it_it2_body_assessment_whtr_band_healthy = /** @type {(inputs: Body_Assessment_Whtr_Band_HealthyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intervallo sano`)
};

/**
* | output |
* | --- |
* | "Healthy range" |
*
* @param {Body_Assessment_Whtr_Band_HealthyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_whtr_band_healthy = /** @type {((inputs?: Body_Assessment_Whtr_Band_HealthyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Whtr_Band_HealthyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_whtr_band_healthy(inputs)
	if (locale === "es-419") return es_419_body_assessment_whtr_band_healthy(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_whtr_band_healthy(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_whtr_band_healthy(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_whtr_band_healthy(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_whtr_band_healthy(inputs)
	return en_us2_body_assessment_whtr_band_healthy(inputs)
});
export { body_assessment_whtr_band_healthy as "body-assessment.whtr_band.healthy" }